<template>
  <div class="flex">
    <div class="search-full-container w-full h-full absolute left-0 top-0" :class="{'flex': showFullSearch}" v-show="showFullSearch">
      <vx-auto-suggest
        ref="navbarSearch"
        :autoFocus="showFullSearch"
        :data="{...navbarSearchAndPinList, ...databaseSearchList}"
        :initialData="searchHistory"
        search_key="title"
        background-overlay
        class="w-full"
        inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
        icon="SearchIcon"
        placeholder="Search In Menu..."
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false"
        @debounce="queryDatabase($event)"
        :loading="loading"
      >
        <template v-slot:group="{ group_name }">
          <p v-if="group_name === 'history'" class="font-semibold text-primary">Search History</p>
          <p v-else class="font-semibold text-primary">{{ group_name | title }}</p>
        </template>

        <!-- Search History -->
        <template v-slot:history="{ suggestion }">
          <div class="flex items-end leading-none py-1">
            <feather-icon icon="ClockIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span class="mt-1">{{ suggestion.search }}</span>
          </div>
        </template>

        <!-- Pages Suggestion -->
        <template v-slot:pages="{ suggestion }">
          <div class="flex items-end leading-none py-1">
            <feather-icon :icon="suggestion.icon" svgClasses="h-5 w-5" class="mr-4" />
            <span class="mt-1">{{ suggestion.title }}</span>
          </div>
        </template>

        <!-- Lists Suggestion -->
        <template v-slot:lists="{ suggestion }">
          <div class="flex items-end leading-none py-1">
            <feather-icon :icon="suggestion.icon" svgClasses="h-5 w-5" class="mr-4" />
            <span class="mt-1">{{ suggestion.title }}</span>
          </div>
        </template>

        <!-- Files Suggestion -->
        <template v-slot:files="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <div class="img-container w-8 mr-3 flex">
                <img :src="get_ext_img(suggestion.file_ext)" :alt="suggestion.file_name" class="responsive">
              </div>
              <div class="leading-none mt-1">
                <p class="mb-1">{{ suggestion.file_name }}</p>
                <small>by {{ suggestion.from }}</small>
              </div>
            </div>
            <small>{{ suggestion.size }}</small>
          </div>
        </template>

        <!-- Contacts Suggestion -->
        <template v-slot:contacts="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img :src="suggestion.img" :alt="suggestion.name" class="w-8 h-8 mr-3 rounded-full">
              <div class="leading-none mt-1">
                <p>{{ suggestion.name }}</p>
                <small>{{ suggestion.email }}</small>
              </div>
            </div>
            <small>{{ suggestion.time }}</small>
          </div>
        </template>

        <!-- No Items Slot -->
        <template v-slot:noResult="{ group_name }">
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span>No results found.</span>
          </div>
        </template>

      </vx-auto-suggest>
      <div class="absolute right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false" />
      </div>
    </div>
    <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer text-primary navbar-fuzzy-search ml-4" />
  </div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'
import axios from '@/axios'

export default {
  components: {
    VxAutoSuggest
  },

  data () {
    return {
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      databaseSearchList: {},
      searchHistory: undefined,
      showFullSearch: false,
      loading: false,
    }
  },

  computed: {
    // below computed property 'get_ext_img' is not required if you are using dynamic image rendering instead of if-else for laravel issue
    get_ext_img () {
      return (ext) => {
        if (ext === 'doc')      return require('@/assets/images/file-icons/doc.png')
        else if (ext === 'jpg') return require('@/assets/images/file-icons/jpg.png')
        else if (ext === 'xls') return require('@/assets/images/file-icons/xls.png')
        else if (ext === 'pdf') return require('@/assets/images/file-icons/pdf.png')
        else return require('@/assets/images/file-icons/doc.png')
      }
    }
  },

  methods: {
    selected (item) {
      if (item.history) {
        this.$refs.navbarSearch.setValue(item.history.search)
        return
      }
      if (item.pages) this.$router.push(item.pages.url).catch(() => {})
      else if (item.lists) this.$router.push(item.lists.url)
      this.showFullSearch = false
    },
    hnd_search_query_update (query) {
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query)
    },
    async queryDatabase (queryString) {
      try {
        this.loading = true
        let { data } = await axios.post('/report/search', { search: queryString })

        // Initialize search history.
        this.searchHistory = (!data.search) ? undefined : {'history': data.search.reverse().slice(0, 5)}

        // Initialize links.
        data = Object.entries(data)
          .filter(element => element[1] !== 0 && element[0] !== 'search') // element[0]=title element[1]=count
          .map(element => {
            return {
              icon: 'FileTextIcon',
              is_bookmarked: false,
              title: `${element[0]} (${element[1]})`,
              url: (element[0] === 'Task') ? `/task/list/search/${queryString}`
                : (element[0] === 'Bill') ? `/billing/search/${queryString}`
                : (element[0] === 'contact') ? `/contacts/search/${queryString}`
                : (element[0] === 'Document') ? `/documents/search/${queryString}`
                : (element[0] === 'Matter') ? `/matters/search/${queryString}`
                : '/404'
            }
          })
        this.databaseSearchList = (data.length > 0) ? {'lists': {data, key: 'title', raw: true}} : []
      } catch (e) {
        this.$message.error('Server error.')
      } finally {
        this.loading = false
      }
    },
  },

  mounted() {
    this.queryDatabase('')
  },
}

</script>
